// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2DeuP","load3":"Spinner_load3__39awk"};